import { useState, type ReactNode } from 'react';
import { palette, transition, admin } from '../../styles/tokens';

interface CardProps {
  title?: string;
  actionLabel?: string;
  onAction?: () => void;
  noPad?: boolean;
  children: ReactNode;
}

export function Card({ title, actionLabel, onAction, noPad, children }: CardProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: palette.white, borderRadius: admin.cardRadius,
        border: `0.5px solid ${hovered ? admin.borderHover : admin.border}`,
        transition: `border-color ${transition.fast}`,
        overflow: 'hidden',
      }}
    >
      {title && (
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '14px 18px 0',
        }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: admin.header }}>{title}</span>
          {actionLabel && (
            <span
              onClick={onAction}
              style={{ fontSize: 12, fontWeight: 500, color: '#0F6CBD', cursor: 'pointer' }}
            >
              {actionLabel}
            </span>
          )}
        </div>
      )}
      <div style={noPad ? {} : { padding: '12px 18px 16px' }}>
        {children}
      </div>
    </div>
  );
}
